// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import styled from 'styled-components';
import { Link } from 'react-router-dom';

import BellIcon from '../../../assets/images/bell.svg';
import LoadingIcon from '../../../assets/images/load.gif';
import Column from '../../../components/Column';
import Row from '../../../components/Row';
import Button from '../../../components/Button';

const S = {
  NotificationWrapper: styled(Column)`
    width: 400px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background-color: white;
    flex: 1;
    z-index: 9;
    overflow: hidden;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  `,
  NotificationHeader: styled(Row)`
    padding: 14px 18px;
    height: 54px;
    background: #EFEFEF;
    font-weight: bold;
    font-size: 18px;
    line-height: 26px;
    color: #434343;
  `,
  NotificationBody: styled.div`
    display: flex;
    width: 100%;
    overflow: auto;
    flex-direction: column;
  `,
  NotificationListItems: styled.ul`
    overflow: auto;
    width: 100%;
    border-top: 1px solid #C0C0C0;
    border-bottom: 1px solid #C0C0C0;

    li {
      .Item {
        display: block;
      }
    }
  `,
  ReadAllButton: styled.span`
    font: 400 14px Noto Sans TC;
    letter-spacing: 0.22px;
    color: #444444;
  `,
  NotificationItemWrapper: styled.div<{isRead: boolean}>`
    padding: 16px 36px 18px 13px;
    border-bottom: 1px solid #DEDEDE;
    display: inline-flex;
    width: 100%;
    ${props => props.isRead ? '' : `
    background: rgba(255, 209, 99, 0.2);`}
  `,
  ReadMark: styled.img`
    margin-top: 0px;
  `,
  ReadMarkWrapper: styled.div`
    width: 8px;
    margin-right: 12px;
  `,
  NotificationItem: styled.li``,
  NotificationTitle: styled.h1`
    font: 400 18px Noto Sans TC;
    letter-spacing: 0.29px;
    color: #444444;
  `,
  Message: styled.div`
    position: relative;
    font-size: 16px;
    line-height: 23px;
    color: #434343;
  `,
  NotificationMessageContainer: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 10px;
  `,
  BellIcon: styled.img.attrs({ src: BellIcon, alt: '' })`
    width: 50px;
  `,
  LoadingIcon: styled.img.attrs({ src: LoadingIcon, alt: '' })`
    width: 100px;
  `,
  NewTag: styled.i`
    width: 5px;
    height: 5px;
    background: #ef8200 0% 0% no-repeat padding-box;
    border-radius: 100%;
    display: block;
    position: absolute;
    top: 50%;
    left: 8px;
  `,
  Time: styled.span`
    font-size: 12px;
    line-height: 17px;
    color: #848484;
  `,
  LoadingText: styled.span`
    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
    color: #929292;
    margin-left: 20px;
  `,
  NoNewText: styled.span`
    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
    color: #929292;
    margin-left: 20px;
  `,
  Button: styled(Button)`
    background: #EF8200;
    font-size: 16px;
    line-height: 23px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    border-radius: 4px;
    margin-top: 15px;
    width: 144px;
    height: 36px;
    box-shadow: revert;
  `,
  ShowAllLink: styled(Link)`
    padding: 6px 0 8px;
    text-align: center;
    font: 400 18px Noto Sans TC;
    letter-spacing: 0.29px;
    color: #EF8200;
  `
};

export { S as default };
